import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PERSONNEL_LOAD,
    ACTION_PERSONNEL_LOAD_BY_ID,

    ACTION_PERSONNEL_SAVE,

    ACTION_PERSONNEL_VALIDATE,

    ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY,

    ACTION_PERSONNEL_CREATE,

    ACTION_PERSONNEL_RESENDEMAIL,

    ACTION_PERSONNEL_PERMISSIONS_LOAD_BY_ID,

    ACTION_PERSONNEL_BY_ROLE_LOAD,

    IPersonnelLoadAction,
    IPersonnelLoadByIdAction,
    IPersonnelLoadFailureAction,
    IPersonnelLoadSuccessAction,

    IPersonnelSaveAction,
    IPersonnelSaveSuccessAction,
    IPersonnelSaveFailureAction,

    IPersonnelValidateAction,
    IPersonnelValidateSuccessAction,
    IPersonnelValidateFailureAction,

    IPersonnelSaveActiveDirectoryAction,
    IPersonnelSaveActiveDirectorySuccessAction,
    IPersonnelSaveActiveDirectoryFailureAction,

    IPersonnelCreateAction,
    IPersonnelCreateSuccessAction,
    IPersonnelCreateFailureAction,

    IPersonnelResendEmailAction,
    IPersonnelResendEmailSuccessAction,
    IPersonnelResendEmailFailureAction,

    IPersonnelPermissionsLoadByIdAction,
    IPersonnelPermissionsLoadFailureAction,
    IPersonnelPermissionsLoadSuccessAction,

    IPersonnelByRoleLoadAction,
    IPersonnelByRoleLoadSuccessAction,
    IPersonnelByRoleLoadFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    ValidateSuccess,
    ValidateFailure,

    // SaveActiveDirectory,
    SaveActiveDirectorySuccess,
    SaveActiveDirectoryFailure,

    CreateSuccess,
    CreateFailure,

    ResendEmailSuccess,
    ResendEmailFailure,

    LoadPermissionsSuccess,
    LoadPermissionsFailure,

    LoadPersonnelByRoleSuccess,
    LoadPersonnelByRoleFailure,
    
    IPersonnelAdvancedSearchSuccessAction,
    IPersonnelAdvancedSearchFailureAction,
    ACTION_PERSONNEL_ADVANCED_SEARCH,
    IPersonnelAdvancedSearchAction,
    AdvancedSearchSuccess,
    AdvancedSearchFailure,
    IPersonnelTMDRoleSuccessAction,
    IPersonnelTMDRoleFailureAction,
    ACTION_PERSONNEL_TMD_ROLE,
    IPersonnelTMDRoleAction,
    TmdRoleSuccess,
    TmdRoleFailure,
    IPersonnelTMDTrialSuccessAction,
    IPersonnelTMDTrialFailureAction,
    ACTION_PERSONNEL_TMD_TRIAL,
    IPersonnelTMDTrialAction,
    TmdTrialSuccess,
    TmdTrialFailure,
    IPersonnelCategorySuccessAction,
    IPersonnelCategoryFailureAction,
    ACTION_PERSONNEL_CATEGORY,
    IPersonnelCategoryAction,
    CategorySuccess,
    CategoryFailure,
    IPersonnelTrialGroupSuccessAction,
    IPersonnelTrialGroupFailureAction, 
    ACTION_PERSONNEL_TRIAL_GROUP, 
    TrialGroupSuccess, 
    TrialGroupFailure

} from "../actions/personnel";
import { personnelApi } from "../services/personnel";


export const
    getPersonnelEpic = (action$): Observable<IPersonnelLoadSuccessAction | IPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_LOAD)
            .mergeMap((_action: IPersonnelLoadAction) => {
                return personnelApi
                    .getPersonnel()
                    .map(response =>
                        LoadSuccess(response.personnel, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getPersonnelByIdEpic = (action$): Observable<IPersonnelLoadSuccessAction | IPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_LOAD_BY_ID)
            .mergeMap((action: IPersonnelLoadByIdAction) => {
                return personnelApi
                    .getPersonnelById(action.id)
                    .map(response =>
                        LoadSuccess(response.personnel, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setPersonnelEpic = (action$): Observable<IPersonnelSaveSuccessAction | IPersonnelSaveFailureAction> => {
        return action$
        .ofType(ACTION_PERSONNEL_SAVE)
        .mergeMap((action: IPersonnelSaveAction) => {
                return personnelApi
                    .setPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.personnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    validatePersonnelEpic = (action$): Observable<IPersonnelValidateSuccessAction | IPersonnelValidateFailureAction> => {
        return action$
        .ofType(ACTION_PERSONNEL_VALIDATE)
        .mergeMap((action: IPersonnelValidateAction) => {
                return personnelApi
                    .validatePersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.personnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    },
    createPersonnelEpic = (action$): Observable<IPersonnelCreateSuccessAction | IPersonnelCreateFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_CREATE)
            .mergeMap((_action: IPersonnelCreateAction) => {
                return personnelApi
                    .createPersonnel()
                    .map(response =>
                        CreateSuccess(response.personnel, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    postPersonnelResendEmailEpic = (action$): Observable<IPersonnelResendEmailSuccessAction | IPersonnelResendEmailFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_RESENDEMAIL)
            .mergeMap((action: IPersonnelResendEmailAction) => {
                return personnelApi
                    .resendEmail(action.id)
                    .map(response => {
                        return ResendEmailSuccess(response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ResendEmailFailure(error.responseStatus))
                    )
            });
    },
    getPersonnelPermissionsByIdEpic = (action$): Observable<IPersonnelPermissionsLoadSuccessAction | IPersonnelPermissionsLoadFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_PERMISSIONS_LOAD_BY_ID)
            .mergeMap((action: IPersonnelPermissionsLoadByIdAction) => {
                return personnelApi
                    .getPersonnelPermissionsById(action.id)
                    .map(response =>
                        LoadPermissionsSuccess(response.groupedPersonnelPermissions, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadPermissionsFailure(error.responseStatus))
                    )
            });
    },
    getPersonnelByRoleEpic = (action$): Observable<IPersonnelByRoleLoadSuccessAction | IPersonnelByRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_BY_ROLE_LOAD)
            .mergeMap((_action: IPersonnelByRoleLoadAction) => {
                return personnelApi
                    .getPersonnelByRole()
                    .map(response =>
                        LoadPersonnelByRoleSuccess(response.rolePersonnelGroupings, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadPersonnelByRoleFailure(error.responseStatus))
                    )
            })
    },
    personnelAdvancedSearchEpic = (action$): Observable<IPersonnelAdvancedSearchSuccessAction | IPersonnelAdvancedSearchFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_ADVANCED_SEARCH)
            .mergeMap((action: IPersonnelAdvancedSearchAction) => {
                return personnelApi
                    .searchPersonnelAdvanced(action.searchPersonnelAdvanced)
                    .map(response =>
                        AdvancedSearchSuccess(response.responseStatus, response.personnel)
                    )
                    .catch(error =>
                        Observable.of(AdvancedSearchFailure(error.responseStatus))
                    )
            });
    },
    personnelTMDRoleEpic = (action$): Observable<IPersonnelTMDRoleSuccessAction | IPersonnelTMDRoleFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_TMD_ROLE)
            .mergeMap((_action: IPersonnelTMDRoleAction) => {
                return personnelApi
                    .getPersonnelTmdRole()
                    .map(response =>
                        TmdRoleSuccess(response.responseStatus, response.tmdRole)
                    )
                    .catch(error =>
                        Observable.of(TmdRoleFailure(error.responseStatus))
                    )
            });
    },
    personnelTMDTrialEpic = (action$): Observable<IPersonnelTMDTrialSuccessAction | IPersonnelTMDTrialFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_TMD_TRIAL)
            .mergeMap((_action: IPersonnelTMDTrialAction) => {
                return personnelApi
                    .getPersonnelTmdTrial()
                    .map(response =>
                        TmdTrialSuccess(response.responseStatus, response.tmdTrial)
                    )
                    .catch(error =>
                        Observable.of(TmdTrialFailure(error.responseStatus))
                    )
            });
    },
    personnelCategoryEpic = (action$): Observable<IPersonnelCategorySuccessAction | IPersonnelCategoryFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_CATEGORY)
            .mergeMap((_action: IPersonnelCategoryAction) => {
                return personnelApi
                    .getPersonnelCategory()
                    .map(response =>
                        CategorySuccess(response.responseStatus, response.category)
                    )
                    .catch(error =>
                        Observable.of(CategoryFailure(error.responseStatus))
                    )
            });
    },
    personnelTrialGroupEpic = (action$): Observable<IPersonnelTrialGroupSuccessAction | IPersonnelTrialGroupFailureAction> => {
        return action$
            .ofType(ACTION_PERSONNEL_TRIAL_GROUP)
            .mergeMap((_action: IPersonnelAdvancedSearchAction) => {
                return personnelApi
                    .getPersonnelTrialGroup()
                    .map(response =>
                        TrialGroupSuccess(response.responseStatus, response.trialGroup)
                    )
                    .catch(error =>
                        Observable.of(TrialGroupFailure(error.responseStatus))
                    )
            });
    }
    
    



